import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import AjioWalletEventConstants from '../../utils/AjioWalletEventConstants';
import { showModal, hideModal } from '../../actions/modal';
import awConstants from '../../utils/AjioWalletConstants';
import Modal from '../common/Modal';
import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import { displayValueWithSymbol } from '../../utils/price';
import { getVariant } from '../../refresh/organism/ABFeature/Feature';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';
import getShowCodConvenienceFlowFlag from '../../refresh/utils/codConvenienceUtils';
import {
  getBlockedForCancellationFlagMsite,
  getCodConvenienceData,
  getEnableAjioMemberShipProgram,
  getFreeShippingAmountLimit,
  getGiftWithProductConfig,
  getGiftWithProductEnable,
  getPriorityDeliveryPostOrderFlag
} from '../../refresh/selectors/featureFlagsSelector';
import Divider from '../../refresh/atoms/Divider';
import { SubscriptionStaticKeys } from './../../constants/subscriptionStaticKey';
import { getMembershipBenefitResponse } from '../../refresh/selectors/cartSelector';
import RupeeSymbol from '../../refresh/atoms/RupeeSymbol';
import { replaceWithJioCDN } from '../../utils/imageHandling'
const {
  TERTIARY_LOGO,
  SAVINGS_ICON,
  CART_ORDER_SUMMERY_HEADING,
  DELIVERY_FEE_SAVING,
  PLATFORM_FEE_SAVING,
  TOTAL_SAVING_HEADING,
  AJIO_FIRST_MEMBERSHIP_DISCOUNT_TEXT,
  CART_DESKTOP_SAVING_TEXT
} = SubscriptionStaticKeys;

const handleKeyDown = e => {
  if (e.code === 'Enter') {
    document.activeElement.click();
  }
};
class AjioFirstSummary extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { memberShipStaticValues = {}, membershipSavingSummery = {}, luxe = false } = this.props;
    const {
      deliveryFeeSavings = 0,
      membershipDiscount = 0,
      platformFeeSavings = 0,
      totalMembershipSavings = 0
    } = membershipSavingSummery || {};
    // const {totalSavings} = membershipBenefitResponse?.userDetail
    const showPriceBreakup = membershipDiscount || platformFeeSavings || deliveryFeeSavings;

    if (!showPriceBreakup) {
      return null;
    }

    return (
      <div className={`first-subscription ${luxe ? 'luxe-first-subscription' : ''}`}>
        <div className="main-head-subscription">
          <img
            className="main-head-subscription-img"
            src={replaceWithJioCDN(memberShipStaticValues?.[TERTIARY_LOGO])}
            alt="AJIO FIRST"
          />
          <span className="main-head-subscription-text">
            <strong>{memberShipStaticValues?.[CART_ORDER_SUMMERY_HEADING]}</strong>
          </span>
        </div>
        <hr class="custom-hr"></hr>
        <div class="layout-container">
          <div class="left main-heading">
            <strong>{memberShipStaticValues?.[CART_DESKTOP_SAVING_TEXT]}</strong>
          </div>
          {deliveryFeeSavings > 0 ? (
            <div className='savings-row'>
              <div class="left">{memberShipStaticValues?.[DELIVERY_FEE_SAVING]}</div>
              <div class="right">
                <RupeeSymbol />
                {Number(deliveryFeeSavings).toFixed(2)}
              </div>
            </div>
          ) : null}
          {platformFeeSavings > 0 ? (
            <div className='savings-row'>
              <div class="left">{memberShipStaticValues?.[PLATFORM_FEE_SAVING]}</div>
              <div class="right">
                <RupeeSymbol />
                {Number(platformFeeSavings).toFixed(2)}
              </div>
            </div>
          ) : null}
          {membershipDiscount > 0 ? (
            <div className='savings-row'>
              <div class="left">
                {memberShipStaticValues?.[AJIO_FIRST_MEMBERSHIP_DISCOUNT_TEXT]}
              </div>
              <div class="right">
                <RupeeSymbol />
                {Number(membershipDiscount).toFixed(2)}
              </div>
            </div>
          ) : null}
          <hr class="custom-hr-total"></hr>
          <div class="special-row">
            <img
              className="sub-saving-icon"
              src={replaceWithJioCDN(memberShipStaticValues?.[SAVINGS_ICON])}
              alt="SAVING"
            />
            <div class="text">
              <strong>{memberShipStaticValues?.[TOTAL_SAVING_HEADING]}</strong>
            </div>
            <div class="additional-text">
              <strong>
                <RupeeSymbol />
                {Math.round(totalMembershipSavings)}
              </strong>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  memberShipStaticValues: state?.cacheData?.staticContent
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AjioFirstSummary);
